import { Box, Typography } from '@mui/material';
import StaticPage from '../../components/StaticPage';

export default function AboutPage() {
    return (
        <StaticPage title="About Us" subtitle="Where brands meet influence.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    The Creator Match is a marketplace that connects brands with creators across Instagram, TikTok,
                    YouTube and more. Finding the right creator for a campaign usually means digging through
                    spreadsheets, cold DMs and outdated media kits. We built The Creator Match so that search,
                    outreach and pricing all live in one place, backed by AI tools that do the matching for you.
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    For creators, that means one profile to manage: your platforms, your content categories
                    and your rates, visible to the brands actually looking for someone like you.
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    For brands, that means a searchable, filterable roster plus an AI Bot and Live AI Search
                    for when you need fresh, ranked results instead of a static list.
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    We're a small team building this in the open as a working product, not a finished
                    enterprise platform — if you run into something rough around the edges, that's why.
                </Typography>
            </Box>
        </StaticPage>
    );
}
